import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';

export const Pill = ({ label, color = C.green, size = 9 }) => (
  <span
    style={{
      background: color + '18',
      color,
      fontSize: size,
      fontWeight: 700,
      padding: '2px 7px',
      borderRadius: 99,
      whiteSpace: 'nowrap',
      display: 'inline-block',
      lineHeight: 1.4,
    }}
  >
    {trU(label)}
  </span>
);
